'use strict';

/*globals TouchNSwipe */
var $ = require('jquery');
var layout = require('../ui/layout.js');
var typeConverter = require('../utils/type-converter.js');
var advert = require('../adverts/advert.js');
var analytics = require('../utils/analytics.js');

var classNames = {
	fullScreenGallery: 'full-screen-gallery'
};

var swipeCount = 0;
var refreshAdsSwipeCount = 3;
var $adverts;

function addSwipeAction(TouchNSwipe) {
	var slider = TouchNSwipe.getSlider(0);
	slider.on('indexchange', function () {
		analytics.trackIpsosIrisPageView();
		swipeCount++;
		if (swipeCount === refreshAdsSwipeCount) {
			advert.loadGalleryAds($adverts);
			swipeCount = 0;
		}
	});
}

function loadTouchNSwipe($context) {
	var galleryLoaded = false;

	var activeThumbIndex = 0;

	$('a[data-link]', $context).each(function () {

		// Don't set up full screen gallery on these links if this is a landing page gallery
		if ($(this).parents('.gallery-slickslider--landing-page').length) {
			return false;
		}

		var $link = $(this);
		var data = $link.attr('data-link');

		if (data && data.indexOf('slider') > -1) {
			var sliderId = typeConverter.getObjectFromString(data).slider;
			if (sliderId) {
				// store the slider id as TouchNSwipe will remove it once loaded
				$link.attr('data-slider', sliderId.substring(1));
			}
		}
	}).on('click.full-screen-gallery', function (e) {
		e.preventDefault();
		var $link = $(this);
		var screenSize = layout.getScreenSize();
		var sliderId = $link.attr('data-slider') || 0;
		if (!galleryLoaded && screenSize === 'XL' || screenSize === 'XXL') {
			var $slides = $.findByBem(classNames.fullScreenGallery, 'slides');
			var $adverts = $.findByBem(classNames.fullScreenGallery, 'adverts').show();
			// data-options must be set before TouchNSwipe+TweenMax is downloaded
			$slides.attr('data-options', $slides.attr('data-options') + ' adjustWidth:-' + $adverts.width() + ';');
		}

		$('a.tnsImg').each(function() {
			var link = $(this);
			var href = link.attr('data-href-' + screenSize);
			if (href) {
				link.attr('href', href);
			}
		});

		require.ensure(['jquery-hammerjs', 'jquery-mousewheel', 'gsap'], function () {
			require('jquery-hammerjs');
			require('jquery-mousewheel');
			require('gsap');
			require('../../vendors/touchnswipe/js/TouchNSwipe.min.js');
			if (!galleryLoaded) {
				galleryLoaded = true;
				// trigger another click so the gallery opens
				$link.trigger('click');
				if (screenSize === 'XL' || screenSize === 'XXL') {
					window.setTimeout(function () {
						advert.loadGalleryAds($adverts);
					}, 500);
					analytics.trackIpsosIrisPageView();
					addSwipeAction(TouchNSwipe);
				}
				var closeGallery = function () {
					var $mainImage = $('.gallery-slickslider').findByBem('slickslider', 'main-images__first');
					var $nextImage = $('.gallery-slickslider').findByBem('slickslider', 'main-images__second');
					var firstScroller = TouchNSwipe.getThumbScroller(0);

					if (firstScroller) {
						activeThumbIndex = firstScroller.index(TouchNSwipe.getSlider(0).index());
					}

					$('.gallery-slickslider').find('.slick-slide').each(function () {
						var $this = $(this);
						$this.removeClass('slick-current');
						if (parseInt($this.attr('data-slick-index')) === activeThumbIndex) {
							$this.addClass('slick-current');
							$mainImage.attr('src', $this.children('a').attr('href'));
							$nextImage.attr('src', $this.children('a').attr('href'));

							var $caption = $('.gallery-slickslider').find('.slickslider__image-caption');

							if ($this.children('a').attr('data-caption')) {
								if ($this.children('a').attr('data-caption').length > 0) {
									$caption.fadeIn();
									$caption.text($this.children('a').attr('data-caption'));
								} else {
									$caption.fadeOut();
								}
							} else {
								$caption.fadeOut();
							}
						}
					});
					$('.slickslider__thumbnails').slick('slickGoTo', activeThumbIndex, true);
				};
				$('*[data-elem="close"]').click(function () {
					closeGallery();
				});
				$(document).keyup(function (e) {
					if (e.keyCode === 27) {
						closeGallery();
					}
				});
			} else {
				window.setTimeout(function () {

					// reset slider so it is centered in screen
					var selectedScroller = TouchNSwipe.getThumbScroller(sliderId);
					var firstScroller = TouchNSwipe.getThumbScroller(0);

					if (selectedScroller) {
						selectedScroller.index(TouchNSwipe.getSlider(sliderId).index());
					}

					if (firstScroller) {
						activeThumbIndex = parseInt($('.slick-current').attr('data-slick-index'));
						TouchNSwipe.getThumbScroller(0).index(activeThumbIndex);
					}

				}, 500);
			}
		}, 'tgGallery');
	});
}

module.exports = {
	init: function ($context) {
		$adverts = $.findByBem(classNames.fullScreenGallery, 'adverts');
		loadTouchNSwipe($context);
	}
};